import { SimpleLocationEntity } from '../../location.types';
import { Captcha, Currency, TransactionStatus } from '../../shared.types';

export type WalletBankResponse = {
  balance: {
    availableBalance: number;
    reservedBalance: number;
    currency: Currency;
  };
  isBankConnected: boolean;
  rtpAvailable: boolean;
  bankName: string;
  bankLastFour: string;
  pendingBalance: number;
  failureFee: number | null;
};

export type WalletBalance = {
  availableBalance: number;
  reservedBalance: number;
  currency: Currency;
};

export type Wallets = {
  balance: WalletBalance;
  pendingBalance: number;
  isBankConnected: boolean;
  rtpAvailable: boolean;
  bankName: string;
  bankLastFour: string;
  simpleLocation: SimpleLocationEntity;
};

export type WalletBankV2Response = {
  failureFee: number | null;
  wallets: Wallets[];
};

export type WithdrawRequest = {
  locationId: number;
  amount: number;
  protocol: PROTOCOL;
  captcha: Captcha;
};

export enum PROTOCOL {
  ach = 'ach',
  rtp = 'rsp',
  standard = 'standard',
}

export type VerifyWithdrawRequest = {
  locationId: number;
  amount: number;
  protocol: PROTOCOL;
  code: string;
};

export type TransactionEntity = {
  id: number;
  status: TransactionStatus;
  amount: number;
  fee: number;
  protocol: PROTOCOL;
  currency: Currency;
  createdAt: string;
};
